import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { LayoutDashboard, Users, BookOpen, FileText, Star, HelpCircle, Image, Calendar, Settings, LogOut, GraduationCap, UserCog, Film, FolderOpen, BarChart3, Mail, Shield, MessageSquare, Bot, ExternalLink, Palette, Instagram, FileEdit, Briefcase, Handshake, Inbox, Navigation } from "lucide-react";
import api from "@/lib/api";

const MENU = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/leads", label: "Leads", icon: Users },
  { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
  { to: "/admin/courses", label: "Courses", icon: BookOpen },
  { to: "/admin/about", label: "About Us Page", icon: FileEdit },
  { to: "/admin/services", label: "Services Page", icon: Briefcase },
  { to: "/admin/partner", label: "Partner With Us", icon: Handshake },
  { to: "/admin/partner-leads", label: "Partner Leads", icon: Inbox },
  { to: "/admin/menu", label: "Website Navigation", icon: Navigation },
  { to: "/admin/slides", label: "Hero Slides", icon: Film },
  { to: "/admin/trainers", label: "Trainers", icon: UserCog },
  { to: "/admin/blogs", label: "Blogs", icon: FileText },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/gallery", label: "Gallery", icon: Image },
  { to: "/admin/instagram", label: "Instagram Sync", icon: Instagram },
  { to: "/admin/events", label: "Events", icon: Calendar },
  { to: "/admin/media", label: "Media Library", icon: FolderOpen },
  { to: "/admin/whatsapp", label: "WhatsApp Automation", icon: MessageSquare },
  { to: "/admin/chatbot", label: "AI Chatbot", icon: Bot },
  { to: "/admin/redirects", label: "Page Redirects", icon: ExternalLink },
  { to: "/admin/branding", label: "Branding & Media", icon: Palette },
  { to: "/admin/users", label: "Users & Roles", icon: Shield },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("eq_admin_token");
    if (!token) { navigate("/admin/login"); return; }
    api.get("/auth/me").catch(() => {
      localStorage.removeItem("eq_admin_token");
      navigate("/admin/login");
    });
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("eq_admin_token");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-neutral-100 flex">
      <aside className="w-64 bg-neutral-950 text-white flex flex-col shrink-0">
        <Link to="/admin" className="flex items-center gap-3 p-6 border-b border-neutral-800">
          {(() => {
            const logo = localStorage.getItem("eq_admin_logo");
            return logo ? (
              <img src={logo} alt="EQtech Admin" className="h-10" />
            ) : (
              <>
                <div className="w-9 h-9 rounded-xl bg-white flex items-center justify-center">
                  <GraduationCap className="w-5 h-5 text-neutral-950" />
                </div>
                <div>
                  <div className="font-display font-black">EQtech</div>
                  <div className="text-[10px] tracking-widest uppercase text-neutral-400">Admin</div>
                </div>
              </>
            );
          })()}
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {MENU.map((m) => (
            <NavLink key={m.to} to={m.to} end={m.end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-sky-500 text-white" : "text-neutral-300 hover:bg-neutral-800"}`}
              data-testid={`admin-nav-${m.label.toLowerCase()}`}>
              <m.icon className="w-4 h-4" /> {m.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-neutral-800">
          <div className="text-xs text-neutral-500 px-3 mb-2">{localStorage.getItem("eq_admin_email")}</div>
          <button onClick={logout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-neutral-300 hover:bg-neutral-800" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
          <Link to="/" className="w-full flex items-center gap-3 px-3 py-2.5 mt-1 rounded-lg text-sm text-neutral-300 hover:bg-neutral-800">
            ← View Site
          </Link>
        </div>
      </aside>
      <main className="flex-1 min-w-0"><Outlet /></main>
    </div>
  );
}
